module.exports = __webpack_public_path__ + "static/media/icone-ia-gradiente.42a27602.svg";